<template>
  <div class="smtPackageOut">
    <el-form
      :model="searchForm"
      ref="searchForm"
      label-width="80px"
      style="overflow: hidden"
      :inline="true"
    >
      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
          v-model="searchForm.startTime"
          align="right"
          type="datetime"
          placeholder="选择开始日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
          v-model="searchForm.endTime"
          align="right"
          type="datetime"
          placeholder="选择结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="是否组包" prop="hasBeenHandover">
        <el-radio-group v-model="searchForm.hasBeenHandover">
          <el-radio
            :label="true"
            @click.native.prevent="cancelSelect(true, 'hasBeenHandover')"
          >
            已组包</el-radio
          >
          <el-radio
            :label="false"
            @click.native.prevent="cancelSelect(false, 'hasBeenHandover')"
            >未组包</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item label="能否组包" prop="canCreateHandover">
        <el-radio-group v-model="searchForm.canCreateHandover">
          <el-radio
            :label="true"
            @click.native.prevent="cancelSelect(true, 'canCreateHandover')"
            >能</el-radio
          >
          <el-radio
            :label="false"
            @click.native.prevent="cancelSelect(false, 'canCreateHandover')"
            >不能</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item prop="searchStr" style="margin-left: 50px">
        <el-input
          style="width: 300px"
          v-model.trim="searchForm.searchStr"
          placeholder="请输入订单号/运单号/物流订单号"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="header-button-box">
      <el-button type="primary" @click="scanPackage">扫码组包</el-button>
      <el-button type="primary" @click="createPackage">创建组包</el-button>
    </div>

    <el-table
      ref="tableList"
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{ textAlign: 'center' }"
      v-loading="tableLoading"
      row-key="id"
      @selection-change="handleSelectionChange"
      highlight-current-row
      v-model="selectRows"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
        :selectable="selectable"
      >
      </el-table-column>
      <el-table-column label="图片" width="100" align="center">
        <template slot-scope="scope">
          <div
            class="details"
            style="display: flex; justify-content: center"
            v-for="item in scope.row.imageList"
            :key="item"
          >
            <div
              class="details_left"
              style="display: flex; justify-content: center"
            >
              <el-popover trigger="hover" placement="right">
                <img :src="item" alt />
                <div class="scope_img" slot="reference">
                  <img :src="item" alt />
                </div>
              </el-popover>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="shopName"
        label="店铺"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="amazonOrderId"
        label="订单号"
        width="240"
        align="center"
      ></el-table-column>
      <el-table-column label="是否组包" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.hasBeenHandover" type="success"
            >已组包</el-tag
          >
          <el-tag v-else type="info">未组包</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="能否组包" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.canCreateHandover" type="success">能</el-tag>
          <el-tag v-else type="danger">不能</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="trackingNumber"
        label="运单号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orderCode"
        label="物流订单号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="weight"
        label="重量(kg)"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      ></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tablePagination.page"
        :page-sizes="pageSizeList"
        :page-size="tablePagination.size"
        layout="total, sizes,prev, pager, next, jumper"
        :total="tablePagination.total"
      ></el-pagination>
    </div>

    <scanPackage
      v-if="scanVisible"
      :visible="scanVisible"
      @cancelVisible="scanVisible = false"
      @submit="scanSubmit"
    ></scanPackage>

    <el-dialog
      title="创建大包"
      :visible="createVisible"
      width="30%"
      @close="closeCreate"
    >
      <span>是否确认将勾选的运单号组合为大包</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="closeCreate"
          :disabled="submitLoading"
          :loading="submitLoading"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createPackageFn"
          :disabled="submitLoading"
          :loading="submitLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <bigPackageDetail
      v-if="detailVisible"
      :visible="detailVisible"
      :currentForm="currentForm"
      @cancelVisible="detailVisible = false"
    >
    </bigPackageDetail>

    <el-dialog
      :title="tipTitle"
      :visible="tipVisible"
      width="30%"
      @close="tipVisible = false"
    >
      <span>{{ tipStr }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tableMixins from "./tableMixins";
import { ajaxPost, Baseurl } from "@/api/api/api";
import scanPackage from "./components/scanPackage.vue";
import bigPackageDetail from "./components/bigPackageDetail.vue";
export default {
  name: "smtPackageOut",
  mixins: [tableMixins],
  data() {
    return {
      searchForm: {
        startTime: "", //开始时间
        endTime: "", //结束时间
        hasBeenHandover: null, //是否组包
        canCreateHandover: null, //能否组包
        searchStr: null, //字符串查询
        searchStrList: [],
      },
      scanVisible: false, //扫码组包
      createVisible: false, // 创建大包
      detailVisible: false, //大包详情

      tipVisible: false,
      tipTitle: "操作失败",
      tipStr: "",
      currentForm: {},
      selectRows: [],
      submitLoading: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    cancelSelect(value, field) {
      if (value === this.searchForm[field]) {
        this.searchForm[field] = null;
      } else {
        this.searchForm[field] = value;
      }
    },
    //表格复选框
    handleSelectionChange(rows) {
      this.selectRows = rows;
    },
    //表格禁用项目
    selectable(row) {
      return !row.hasBeenHandover || row.canCreateHandover;
    },
    getList() {
      const sendData = {
        page: this.tablePagination.page,
        size: this.tablePagination.size,
        ...this.searchForm,
      };
      const API = Baseurl + "aliexpressParcel/selectAliexpressParcels";

      this.tableLoading = true;
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            const { list, total } = data;
            this.tableData = list;
            this.tablePagination.total = total;
          } else {
            this.$message.error(data);
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.getList();
    },
    search() {
      this.getList();
    },

    //扫码组包
    scanPackage() {
      this.scanVisible = true;
    },
    //扫码确认提交
    scanSubmit(obj) {
      const { flag, message, id } = obj;
      if (flag) {
        //创建成功 关闭创建开启详情
        this.currentForm = { id };
        this.scanVisible = false;
        this.detailVisible = true;
      } else {
        //创建失败
        this.tipVisible = true;
        this.tipStr = message;
      }
    },

    //创建大包
    createPackage() {
      if (this.selectRows?.length > 0) {
        this.createVisible = true;
      } else {
        this.$message.error("请选择需要组包的数据！");
      }
    },
    createPackageFn() {
      const API = Baseurl + "aliexpressParcel/commitHandover";
      this.submitLoading = true;
      const sendData = this.selectRows?.map((ele) => {
        return {
          id: ele.id,
          sellerId: ele.sellerId,
          orderCode: ele.orderCode,
          weight: ele.weight,
        };
      });
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.$message.success("创建成功");
            this.$refs.tableList.clearSelection(); //清空选中数据
          } else {
            this.tipTitle = "操作失败";
            this.tipStr = data;
            this.tipVisible = true;
          }
          this.createVisible = false;
          this.submitLoading = false;
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },
    closeCreate() {
      this.createVisible = false;
    },
  },
  components: {
    scanPackage,
    bigPackageDetail,
  },
};
</script>
<style lang="scss" scoped>
.smtPackageOut {
  color: red;
  padding-top: 10px;

  .header-button-box {
    margin-bottom: 20px;
  }

  .scope_img {
    width: 55px;
    height: 55px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .prduct_img {
    width: 500px;
    height: 500px;
  }

  .cell {
    display: flex;
    justify-content: center;
    align-items: center;
    .scope_img {
      display: initial;
    }

    .scope_img img {
      width: 55px;
      height: 55px;
    }
  }

  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .details_left {
    width: 30%;
    text-align: center;
  }

  .details_right {
    width: 70%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .pagination-container {
    width: 1660px;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;

    .el-pagination {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
